import { FormEvent, useEffect, useState } from "react";
import { supabase } from "./lib/supabase";

type ReaderSettings = { provider: "disabled" | "openai"; daily_limit: number };

export function StandInvoiceReadingSettings({ organizationId, canManage }: { organizationId: string; canManage: boolean }) {
  const [settings, setSettings] = useState<ReaderSettings>({ provider: "disabled", daily_limit: 10 });
  const [notice, setNotice] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data, error } = await supabase.rpc("invoice_reader_settings", { p_organization_id: organizationId }).maybeSingle();
    if (error) setNotice(error.message);
    else if (data) setSettings(data as ReaderSettings);
    setLoading(false);
  };
  useEffect(() => { void load(); }, [organizationId]);

  const save = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setBusy(true);
    const form = new FormData(event.currentTarget);
    const result = await supabase.rpc("configure_invoice_reader", {
      p_organization_id: organizationId,
      p_automatic: form.get("automatic") === "on",
      p_daily_limit: Number(form.get("daily_limit")),
    });
    setNotice(result.error?.message ?? "Configuração guardada.");
    if (!result.error) await load();
    setBusy(false);
  };

  return <form className="settings-form invoice-reader-settings" data-loaded={!loading} aria-busy={loading} onSubmit={save}>
    <div className="settings-copy">
      <h4>Leitura de faturas</h4>
      <p>Quando estiver ativa, o sistema preenche uma proposta. Um responsável confirma sempre os valores antes de criar o custo.</p>
    </div>
    <label className="settings-checkbox">
      <input name="automatic" type="checkbox" checked={settings.provider === "openai"} onChange={(event) => setSettings((current) => ({ ...current, provider: event.target.checked ? "openai" : "disabled" }))} disabled={!canManage || busy || loading} />
      <span>Utilizar leitura automática</span>
    </label>
    <label>
      <span>Máximo de leituras por dia</span>
      <small className="field-help">Limite de faturas que podem ser interpretadas automaticamente por dia; não limita uploads manuais.</small>
      <input name="daily_limit" type="number" min="1" max="1000" value={settings.daily_limit} onChange={(event) => setSettings((current) => ({ ...current, daily_limit: Number(event.target.value) }))} disabled={!canManage || busy || loading} />
    </label>
    {notice && <p className="settings-notice" role="status">{notice}</p>}
    {loading && <p className="settings-notice" role="status">A carregar configuração…</p>}
    {canManage && <button className="stock-primary" disabled={busy || loading}>{busy ? "A guardar…" : "Guardar"}</button>}
  </form>;
}
